import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  clear() {
    localStorage.clear();
  }

  getObject(key: string) {
    return JSON.parse(localStorage.getItem(key) || '{}') || {};
  }

  getValue(key: string) {
    return JSON.parse(localStorage.getItem(key) || '""');
  }

  remove(key: string) {
    localStorage.removeItem(key);
  }

  set(key: string, value: any): boolean {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  }
}
